import { render, staticRenderFns } from "./Select_user.vue?vue&type=template&id=b2711180&scoped=true"
import script from "./Select_user.vue?vue&type=script&lang=js"
export * from "./Select_user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2711180",
  null
  
)

export default component.exports